"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _Error = _interopRequireDefault(require("../Error"));

var Styled = _interopRequireWildcard(require("./Group.style"));

var _Hint = _interopRequireDefault(require("../Hint"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var GroupContext = (0, _react.createContext)({
  inGroup: false,
  name: ''
});
exports.GroupContext = GroupContext;

var Group = function Group(_a) {
  var children = _a.children,
      hint = _a.hint,
      label = _a.label,
      name = _a.name;
  return _react.default.createElement(GroupContext.Provider, {
    value: {
      inGroup: true,
      name: name
    }
  }, _react.default.createElement(Styled.FieldSet, {
    as: "fieldset",
    id: name,
    tabIndex: -1,
    my: "16px"
  }, label && _react.default.createElement(Styled.GroupLegend, null, label), hint && _react.default.createElement(_Hint.default, {
    pb: 1
  }, hint), _react.default.createElement(_formik.ErrorMessage, {
    component: _Error.default,
    name: name
  }), _react.default.createElement(Styled.GroupItems, {
    as: "section",
    hasLabel: !!label
  }, children)));
};

Group.displayName = 'Group';
Group.defaultProps = {
  label: ''
};
var _default = Group;
exports.default = _default;